import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { IoMdMail } from "react-icons/io";

const EmailSent = () => {
    const [timer, setTimer] = useState(5);
    const location = useLocation();
    const navigate=useNavigate();
    let stateObj = location?.state;
    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(prevCount => {
                if (prevCount <= 0) { 
                    clearInterval(interval);  
                    if (stateObj?.registerFor === 'club' || stateObj?.registerFor === 'player' || stateObj?.registerFor === 'guest'){
                        navigate('/verify',{state: stateObj});  
                    }
                    else{
                        navigate('/reset-password', {state:{userEmail:stateObj?.userEmail}});  
                    }
                }
                return prevCount - 1;  
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [])
    return (
        <div className='email_sent_container'>
            <h4>We've Sent a Verification Code to Your Email</h4>
            <div className='email_sent_body'>
                 <IoMdMail style={{fontSize:150,paddingTop:15,color:'var(--hoverColorBold)'}}/>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className='longfazers'>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <h1 className='email_sent_redirect'>Redirecting in {timer} s.......</h1>

        </div>
    )
}

export default EmailSent